import React, { useContext } from "react";
import { Switch, Route } from "react-router-dom";
import Menu from "./pages/Menu/Menu";
import bg from "./assets/prism.png";
import Header from "./components/Header/Header";
import LoginPage from "./pages/Login/LoginPage";
import { AuthContext } from "./AuthContext";
import Footer from "./components/Footer/Footer";
import AddMenu from "./pages/Menu/AddMenu";
import Restaurants from "./pages/Menu/Restaurants";
import Settings from "./pages/Settings/Settings";
import AddStoreToUser from "./pages/Admin/AddStoreToUser";
import Loyalty from "./pages/Loyalty/Loyalty";

function App() {
	const {
		isLoggedIn,
		isLoading,
		userData,
		databasesRef: { isUserManager, isDev },
	} = useContext(AuthContext);

	const style = {
		boxSizing: "border-box",
		minHeight: "100vh",
		background: `url(${bg}) 100% 100% repeat`,
		backgroundSize: "2000px",
		backgroundColor: "#202060",
		paddingTop: "1em",
	};

	const defaultRoutes = (
		<>
			<Route exact path="/">
				<div></div>
			</Route>
			<Route exact path="/menu">
				<Menu />
			</Route>
			<Route path="/add">
				<AddMenu path="add" />
			</Route>
			<Route path="/categories">
				<AddMenu path="categories" />
			</Route>
			<Route path="/settings">
				<Settings />
			</Route>
			<Route path="/lealtad">
				<Loyalty />
			</Route>
		</>
	);

	const Router = () => (
		<>
			<Header isUserManager={isUserManager} />
			<Switch>{defaultRoutes}</Switch>
			<Footer userData={userData} />
		</>
	);

	const RouterManager = (props) => (
		<>
			<Header {...props} />
			<Switch>{defaultRoutes}</Switch>
			<Footer userData={userData} />
		</>
	);

	const RouterDeveloper = (props) => (
		<>
			<Header {...props} />
			<Switch>
				<Route path="/store">
					<Restaurants />
				</Route>
				<Route path="/userStore">
					<AddStoreToUser />
				</Route>
				{defaultRoutes}
			</Switch>
			<Footer userData={userData} />
		</>
	);

	const RouterHandler = () => {
		if (isDev) return <RouterDeveloper isDev={isDev} />;
		if (isUserManager) return <RouterManager isUserManager={isUserManager} />;
		return <Router />;
	};

	return <div style={style}>{isLoggedIn ? <RouterHandler /> : <LoginPage isLoading={isLoading} />}</div>;
}

export default App;
